const ATTENTION_CODES = new Set([
  'analytics_delivery_exhausted',
  'analytics_delivery_retrying',
  'checkout_pending',
  'checkout_recovery_available',
]);

const CHECKOUT_STATUSES = new Set(['none', 'creating', 'open', 'completed', 'failed']);
// Catalogue plan ids (and legacy tier keys from older checkout attempts).
const PLANS = new Set(['solo', 'team', 'business', 'business_capacity', 'pro']);
const CYCLES = new Set(['monthly', 'yearly']);
const counter = (value) => (
  Number.isInteger(value) && value >= 0 ? value : 0
);

/**
 * Keep the billing UI on the documented aggregate-only contract even if a
 * backend/proxy accidentally adds identifiers or provider details later.
 */
export const normalizeOperationalHealth = (value) => {
  const outbox = value?.outbox || {};
  const checkout = value?.checkout || {};
  return {
    outbox: {
      pending: counter(outbox.pending),
      sent: counter(outbox.sent),
      failed: counter(outbox.failed),
      exhausted: counter(outbox.exhausted),
    },
    checkout: {
      status: CHECKOUT_STATUSES.has(checkout.status) ? checkout.status : 'none',
      needsAttention: checkout.needsAttention === true,
      plan: PLANS.has(checkout.plan) ? checkout.plan : null,
      billingCycle: CYCLES.has(checkout.billingCycle) ? checkout.billingCycle : null,
    },
    attention: Array.isArray(value?.attention)
      ? value.attention
        .filter((item) => ATTENTION_CODES.has(item?.code))
        .map((item) => ({ code: item.code }))
      : [],
  };
};
